import { Injectable } from '@angular/core';

import { Store, StoreConfig } from '@datorama/akita';

import { AuthUser } from '@shared/signup/models';

// TODO: rename
@Injectable({providedIn: 'root'})
@StoreConfig({name: 'authRestaurant'})
export class AuthRestaurantStore extends Store<AuthUser> {
  constructor() {
    super({});
  }
}
